import * as React from "react"

const Error = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M8 13.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11ZM14.5 8a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0ZM8 10.5A.75.75 0 1 0 8 12a.75.75 0 0 0 0-1.5Zm-.5-2.05a.5.5 0 0 0 1 0V4.5a.5.5 0 0 0-1 0v3.95Z" />
  </svg>
)

export default Error
